// Public
export const RUTA_LOGIN = "/login";
export const RUTA_INICIO = "/inicio";
export const RUTA_NO_AUTORIZADA = "/no-autorizada";

// Propietarios
export const RUTA_PROPIETARIOS = "/propietarios";
export const RUTA_PROPIETARIOS_CREAR = "/propietarios/crear";
export const RUTA_PROPIETARIOS_EDITAR = "/propietarios/:idPropietario/editar";
export const RUTA_PROPIETARIOS_ID = "/propietarios/:idPropietario";
export const RUTA_PROPIETARIOS_MASCOTAS_CREAR = "/propietarios/:idPropietario/mascotas/crear";
export const RUTA_PROPIETARIOS_MASCOTAS = "/propietarios_mascotas";

// Mascotas
export const RUTA_MASCOTAS = "/mascotas";
export const RUTA_MASCOTAS_EDITAR = "/mascotas/:idMascota/editar";
export const RUTA_MASCOTAS_ID = "/mascotas/:idMascota";

// Servicios
export const RUTA_SERVICIOS = "/servicios";
export const RUTA_SERVICIOS_PRODUCTOS = "/servicios_productos";
export const RUTA_SERVICIOS_GUARDERIA = "/servicios/guarderia";
export const RUTA_SERVICIOS_GUARDERIA_CREAR = "/servicios/guarderia/crear";
export const RUTA_SERVICIOS_GUARDERIA_ID = "/servicios/guarderia/:idServicio";
export const RUTA_SERVICIOS_HOTEL = "/servicios/hotel";
export const RUTA_SERVICIOS_HOTEL_CREAR = "/servicios/hotel/crear";
export const RUTA_SERVICIOS_HOTEL_ID = "/servicios/hotel/:idServicio";
export const RUTA_SERVICIOS_ENTRENAMIENTO = "/servicios/entrenamiento";
export const RUTA_SERVICIOS_ENTRENAMIENTO_CREAR = "/servicios/entrenamiento/crear";
export const RUTA_SERVICIOS_ENTRENAMIENTO_ID = "/servicios/entrenamiento/:idServicio";
export const RUTA_SERVICIOS_SPA = "/servicios/spa";
export const RUTA_SERVICIOS_SPA_CREAR = "/servicios/spa/crear";
export const RUTA_SERVICIOS_SPA_ID = "/servicios/spa/:idServicio";
export const RUTA_SERVICIOS_TRANSPORTE = "/servicios/transporte";
export const RUTA_SERVICIOS_TRANSPORTE_CREAR = "/servicios/transporte/crear";
export const RUTA_SERVICIOS_TRANSPORTE_ID = "/servicios/transporte/:idServicio";

// Productos
export const RUTA_PRODUCTOS = "/productos";
export const RUTA_PRODUCTOS_CREAR = "/productos/crear";
export const RUTA_PRODUCTOS_ID = "/productos/:idProducto";

// Reservas
export const RUTA_RESERVAS = "/reservas";
export const RUTA_RESERVAS_GUARDERIA = "/reservas/guarderia";
export const RUTA_RESERVAS_GUARDERIA_CREAR = "/reservas/guarderia/crear";
export const RUTA_RESERVAS_GUARDERIA_LISTAR = "/reservas/guarderia/listar";
export const RUTA_RESERVAS_GUARDERIA_CANCELAR = "/reservas/guarderia/:idAgendamiento/cancelar";
export const RUTA_RESERVAS_GUARDERIA_ID = "/reservas/guarderia/:idAgendamiento";
export const RUTA_RESERVAS_HOTEL = "/reservas/hotel";
export const RUTA_RESERVAS_HOTEL_CREAR = "/reservas/hotel/crear";
export const RUTA_RESERVAS_HOTEL_LISTAR = "/reservas/hotel/listar";
export const RUTA_RESERVAS_HOTEL_CANCELAR = "/reservas/hotel/:idAgendamiento/cancelar";
export const RUTA_RESERVAS_HOTEL_ID = "/reservas/hotel/:idAgendamiento";
export const RUTA_RESERVAS_SPA = "/reservas/spa";
export const RUTA_RESERVAS_SPA_CREAR = "/reservas/spa/crear";
export const RUTA_RESERVAS_SPA_LISTAR = "/reservas/spa/listar";
export const RUTA_RESERVAS_SPA_ID = "/reservas/spa/:idAgendamiento";
export const RUTA_RESERVAS_ENTRENAMIENTO = "/reservas/entrenamiento";

// Ventas
export const RUTA_VENTAS = "/ventas";
export const RUTA_VENTAS_POR_PAGAR = "/ventas/por_pagar";
export const RUTA_VENTAS_HISTORIAL = "/ventas/historial";
export const RUTA_VENTAS_ID = "/ventas/:idVenta";

// Asistencia
export const RUTA_ASISTENCIA = "/asistencia";
export const RUTA_ASISTENCIA_PROYECCIONES = "/asistencia/proyecciones";
export const RUTA_ASISTENCIA_CHECKIN = "/asistencia/checkin";
export const RUTA_ASISTENCIA_CHECKIN_ID = "/asistencia/checkin/:idLista";
export const RUTA_ASISTENCIA_SPA_PROYECCIONES = "/asistencia_spa/proyecciones";
export const RUTA_ASISTENCIA_SPA_CHECKIN = "/asistencia_spa/checkin";

// Transporte
export const RUTA_TRANSPORTE = "/transporte";
export const RUTA_TRANSPORTE_HOY = "/transporte/hoy";
export const RUTA_TRANSPORTE_PLANEACION = "/transporte/planeacion";

// Compras
export const RUTA_COMPRAS = "/compras";
export const RUTA_COMPRAS_COMPRAR = "/compras/comprar";

// Carrito
export const RUTA_CARRITO = "/carrito";

// Comunicaciones
export const RUTA_COMUNICACIONES = "/comunicaciones";
export const RUTA_COMUNICACIONES_REPORTE_DIARIO = "/comunicaciones/reporte_diario";
export const RUTA_COMUNICACIONES_CORREOS_MASIVOS = "/comunicaciones/correos_masivos";
export const RUTA_COMUNICACIONES_CORREOS_MASIVOS_PLANTILLA = "/comunicaciones/correos_masivos/:idPlantilla";

// Analisis
export const RUTA_ANALISIS = "/analisis";
export const RUTA_ANALISIS_ENGLISH = "/analysis";
export const RUTA_ANALISIS_FINANZAS = "/analisis/finanzas";
export const RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES = "/analisis/finanzas/ingresos-por-mes";
export const RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA = "/analisis/finanzas/ingresos-por-dia";
export const RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO = "/analisis/finanzas/ingresos-por-propietario";
export const RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA = "/analisis/finanzas/ingresos-por-mascota";
export const RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO = "/analisis/finanzas/ingresos-por-servicio";
export const RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO = "/analisis/finanzas/deudas-por-propietario";
export const RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES = "/analisis/finanzas/descuentos-por-mes";
export const RUTA_ANALISIS_OPERACIONES = "/analisis/operaciones";
export const RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS = "/analisis/operaciones/asistencias-por-dias";
export const RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA = "/analisis/operaciones/planes-activos-por-dia";
export const RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS = "/analisis/operaciones/planes-activos";
export const RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS = "/analisis/operaciones/guarderia/mascotas-desertoras";
export const RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS = "/analisis/operaciones/vacunas-vencidas";

// Seguridad
export const RUTA_SEGURIDAD = "/seguridad";
export const RUTA_SEGURIDAD_ASIGNAR_ROLES = "/seguridad/asignar-roles";
export const RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS = "/seguridad/administrar-usuarios";

// OAuth Google
export const RUTA_OAUTH_GOOGLE_CALLBACK = "/oauth/google/callback";
